import { render } from "./Pagination.vue?vue&type=template&id=b1d4da4c"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/navigation/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b1d4da4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b1d4da4c', __exports__)) {
    console.log('reload')
    api.reload('b1d4da4c', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=b1d4da4c", () => {
    console.log('re-render')
    api.rerender('b1d4da4c', render)
  })

}


export default __exports__